import SvgPdsMarkerIcon from './SvgPdsMarkerIcon'

export default SvgPdsMarkerIcon
